import '../styles/DashboardPreview.css';

const DashboardPreview = () => {
    return (
        <div className="section dashboard-section" id="dashboard-preview">
            <div className="container">
                <h2 className="section-title"><span className="highlight-orange">무료</span>로 시작하는 AI · IoT 클라우드 플랫폼</h2>
                <p className="dashboard-desc">
                    IoT 센서 수집 → On-Device AI 현장 판단 → Physical AI 액추에이터 제어 → 클라우드 AI 빅데이터 분석까지, <span className="highlight-orange">No Coding</span>으로 연결
                </p>

                <div className="dashboard-mockup">
                    <div className="dashboard-tile tile-large">
                        <div className="tile-header">Power Consumption</div>
                        <div className="tile-content chart-placeholder">
                            <div className="chart-line"></div>
                        </div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Temperature</div>
                        <div className="tile-value">24.5°C</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Humidity</div>
                        <div className="tile-value">45%</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Status</div>
                        <div className="tile-value status-active">Active</div>
                    </div>
                    <div className="dashboard-tile">
                        <div className="tile-header">Devices</div>
                        <div className="tile-value">12</div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default DashboardPreview;
